import { useState, useCallback } from 'react';
import { getNotas, confirmarNota as confirmarNotaService, rechazarNota as rechazarNotaService, deleteNota as deleteNotaService } from '../../../services/notas-autorizacion-nuevo.service';
import useFeedbackModal from '../../../hooks/useFeedbackModal';

export const useNotasAutorizacionAdmin = () => {
  const { showSuccess, showError } = useFeedbackModal();
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNotas = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getNotas();
      setNotas(data);
    } catch (err) {
      setError(err.message);
      showError({ title: 'Error', description: err.message });
    } finally {
      setLoading(false);
    }
  }, [showError]);

  const confirmarNota = async (id, cursosModificados) => {
    try {
      const res = await confirmarNotaService(id, cursosModificados);
      const destinatarioEmail = res.destinatario_email;

      await showSuccess({
        title: '¡Autorización confirmada exitosamente!',
        confirmText: 'ACEPTAR',
        confirmButtonColor: '#00a651',
        confirmButtonHoverColor: '#008e45',
        confirmButtonActiveColor: '#007a3b',
        centerButton: true,
        maxWidth: '512px',
        notificationBanner: destinatarioEmail
          ? {
              email: destinatarioEmail,
              message: 'informando la autorización de los cursos.',
            }
          : null,
      });

      fetchNotas();
      return true;
    } catch (err) {
      showError({ title: 'Error', description: err.message });
      return false;
    }
  };

  const rechazarNota = async (id, motivoRechazo) => {
    try {
      const res = await rechazarNotaService(id, motivoRechazo);
      const destinatarioEmail = res.destinatario_email;

      await showSuccess({
        title: '¡Nota Rechazada Exitosamente!',
        description: `La nota de autorización #${id} ha sido rechazada.`,
        detail: destinatarioEmail
          ? {
              text: 'Se ha enviado un correo electrónico a',
              highlight: destinatarioEmail,
              suffix: 'con el motivo del rechazo y los pasos a seguir.',
            }
          : null,
        confirmText: 'Aceptar',
      });
      fetchNotas();
      return true;
    } catch (err) {
      showError({ title: 'Error', description: err.message });
      return false;
    }
  };

  const eliminarNota = async (id) => {
    try {
      await deleteNotaService(id);
      await showSuccess({
        title: '¡Nota Eliminada Exitosamente!',
        description: `La Nota de Autorización #${id} ha sido eliminada correctamente.`,
        confirmText: 'Aceptar',
      });
      fetchNotas();
      return true;
    } catch (err) {
      showError({ title: 'Error', description: err.message });
      return false;
    }
  };

  return {
    notas,
    loading,
    error,
    fetchNotas,
    confirmarNota,
    rechazarNota,
    eliminarNota,
  };
};

